import { useMemo } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { useGetAllTemplatesOnMount } from '@user/store/agreements/hooks/useGetAllTemplatesOnMount'
import { useLoadEntityLocationsOnMount } from '@user/store/entityLocations'
import { useGetLeadOppProductsOnMount } from '@user/store/leadOppProducts/hooks/useGetLeadProductsOnMount'
import { useGetServiceFrequenciesOnMount } from '@user/store/serviceFrequency/hooks/useGetServiceFrequenciesOnMount'
import { CreateAgreementFormPacketModel } from '@user/components/Agreements/AgreementFormPacketDialog/typings'

type Params = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function useData(params: Params) {
  const { entityId, entityType } = params

  const serviceFreqStatus = useGetServiceFrequenciesOnMount()
  const serviceLocationStatus = useLoadEntityLocationsOnMount(
    entityId,
    entityType,
  )

  const templateStatus = useGetAllTemplatesOnMount(params)

  const servicesStatus = useGetLeadOppProductsOnMount(entityId, entityType)

  const loading =
    templateStatus === 'pending' ||
    serviceFreqStatus === 'pending' ||
    serviceLocationStatus === 'pending' ||
    servicesStatus === 'pending'

  const failed =
    templateStatus === 'fail' ||
    serviceFreqStatus === 'fail' ||
    serviceLocationStatus === 'fail' ||
    servicesStatus === 'fail'

  const success =
    templateStatus === 'success' &&
    serviceFreqStatus === 'success' &&
    serviceLocationStatus === 'success' &&
    servicesStatus === 'success'

  const initialValues = useMemo<CreateAgreementFormPacketModel>(
    () => ({
      entityId,
      entityType,
      templates: [],
    }),
    [entityId, entityType],
  )

  return {
    loading,
    failed,
    success,
    initialValues,
  }
}
